<template>
  <div :class="cssClasses">
    <!-- Table starts here -->
    <table
      v-if="placed_bets && placed_bets.length > 0"
      id="table"
      class="table table-hover table-bordered"
    >
      <thead>
        <tr>
          <th>User</th>
          <th>Bet On</th>
          <th>Amount Bet</th>
          <th>Amount Won</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(placed, index) in placed_bets" :key="index">
          <td data-title="User">
            <User :user_id="placed.user_id"></User>
          </td>
          <td data-title="Bet">{{$store.state.bets[bet_id].options[placed.option][0]}}</td>
          <td data-title="Amount">{{formatCurrency(placed.amount)}}</td>
          <td
            data-title="Won"
          >{{placed.amount_won ? (placed.status === 2) ? formatCurrency(placed.amount_won) : "-" : "?"}}</td>
        </tr>
      </tbody>
    </table>
    <div v-else>No bets placed</div>
  </div>
</template>

<script>
// import { mapState } from 'vuex'

export default {
  name: 'placed-bets',
  props: ['bet_id', 'placed_bets', 'size'],
  async created () {

  },
  data () {
    return {
      wat: []
    }
  },
  computed: {
    cssClasses () {
      let classes = ['table-responsive-vertical', 'shadow-z-1']
      if (this.size === 'mini') {
        classes.unshift('table-mini')
      }
      return classes.join(' ')
    }
    // placedBets () {
    //   // console.log('STORE', this.$store.state.placedBets)
    //   return (this.$store.state.placedBets[this.bet_id] || []).concat(this.wat)
    // }
  },
  methods: {
    async refreshPlacedBets () {
      // console.log('bet id', this.bet_id)

      await this.$store.dispatch('fetchPlacedBets', this.bet_id)
      // console.log('res', res)
    }
  }
}
</script>

<style scoped>
table {
  width: 100%;
  border: 2px #b62626 solid;
  border-radius: 3px;
  border-collapse: separate;
  border-spacing: 0px;
}
tbody tr:nth-child(even) {
  background-color: rgba(0, 0, 0, 0.3);
}
tbody tr:nth-child(odd) {
  background-color: rgba(0, 0, 0, 0.2);
}
table tr {
  height: 40px;
  transition: background-color 0.2s;
}
tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.5);
}
thead {
  background-color: #b62626;
  font-weight: bold;
  font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/Placed-Bets.vue